module.exports = __webpack_public_path__ + "img/tipp-cross.640dee0d.svg";